import React, { useState, useEffect } from 'react';
import profileIcon from '../assets/ic--round-person.png'
import { faMobileScreen, faUser, faEnvelope, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateProfile } from '../apiServices/apiServices';
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom';
import CustomToastContainer from '../components/CustomToastContainer';

export default function MyProfile() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  });

  const [data, setData] = useState({
    fullName: '',
    phone: '',
    email: '',
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const user = JSON.parse(window.localStorage.getItem("user"));

      const fetchedData = {
        fullName: user.fullname,
        phone: user.phone,
        email: user.email,
      };
      setData(fetchedData);
      const [firstName, lastName] = fetchedData.fullName.split(' ');
      setProfile({
        firstName,
        lastName,
        phone: fetchedData.phone,
        email: fetchedData.email,
      });
    };

    fetchProfileData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
    if (name === "firstName" || name === "lastName") {
      setData((prevData) => ({
        ...prevData,
        fullName: name === "firstName"
          ? `${value} ${profile.lastName}`
          : `${profile.firstName} ${value}`,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleUpdate = async () => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    try {
      const response = await updateProfile(user.id, data );
      // console.log("Response : ", response);
      if (response && response.success) {
        const passenger = response.data.passenger;
        localStorage.setItem("user", JSON.stringify(passenger));
        toast.success('Profile Updated!')
      } else {
        toast.error(response.message || 'Request failed');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again.');
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return(
    <div className='bg-gray-100 h-screen'>
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>

          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
            My Profile
            </h1>
          </div>
        </nav>       

      <div className=" flex flex-col items-center justify-center  p-4">
        <div className="w-full md:w-1/2 py-4">
          <div className="flex items-center justify-center mb-6">
            <div className="w-40 h-40 rounded-full bg-gray-200 flex items-center justify-center">
              <div className="w-32 h-32 rounded-full overflow-hidden">
                <img
                  src={profileIcon}
                  alt="User"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-5">
              <div className="w-full sm:w-3/4 2" >
                  <div className="mb-4 space-y-4">
                    <div className="relative z-0 w-full mb-5 group block">
                      <FontAwesomeIcon
                        icon={faUser}
                        className="absolute text-[#BE1F18] left-0 top-3"
                      />
                      <label className="peer-focus:font-semi-bold absolute left-8 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 block text-[#BE1F18] text-md font-semibold mb-2" htmlFor="firstName">
                        First Name
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={profile.firstName}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        className="block py-2.5 pl-8 w-full text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                      />
                    </div>

                    <div className="relative z-0 w-full mb-5 group block">
                      <FontAwesomeIcon
                        icon={faUser}
                        className="absolute text-[#BE1F18] left-0 top-3"
                      />
                      <label className="peer-focus:font-semi-bold absolute left-8 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 block text-[#BE1F18] text-md font-semibold mb-2" htmlFor="lastName">
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={profile.lastName}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        className="block py-2.5 pl-8 w-full text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                      />
                    </div>

                    <div className="relative z-0 w-full mb-5 group block">
                      <FontAwesomeIcon
                        icon={faMobileScreen}
                        className="absolute text-[#BE1F18] left-0 top-3"
                      />
                        <label htmlFor="phone" className="peer-focus:font-semi-bold absolute left-8 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 block text-[#BE1F18] text-md font-semibold mb-2">            
                          Phone
                        </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={profile.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        className="block py-2.5 pl-8 w-full text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                      />
                    </div>

                    <div className="relative z-0 w-full mb-5 group block">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="absolute text-[#BE1F18] left-0 top-3"
                      />
                      <label className="peer-focus:font-semi-bold absolute left-8 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 block text-[#BE1F18] text-md font-semibold mb-2" htmlFor="email">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={profile.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        className="block py-2.5 pl-8 w-full text-gray-700 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                      />
                    </div>
                  </div>
                  <button
                      type="submit"
                      onClick={handleUpdate}
                      className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center mt-5"
                  >
                      Update
                  </button>
              </div>
          </div>
        </div>
      </div>
      <CustomToastContainer/>
    </div>
  );
}
